import { path } from 'ramda';

function sanitizeButtonsBeforeSendingToEvoWrapper(buttons, locale, widgets) {
  return buttons.map((button) => {
    if (button.action === 'home' && !widgets.home) {
      return {
        action: 'back',
        label: path([ 'general', 'go_back' ], locale),
        primary: button.primary,
      };
    }

    /**
     * Currently used only for cashier, if cashier is false,
     * we return null and filter the array after mapping
     */
    if (widgets[button.action] === false) return null;

    return {
      action: button.action,
      label: path(button.intlKey.split('.'), locale),
      primary: button.primary,
    };
  }).filter((button) => button !== null);
}

export function getOssDialogLocalizedData(dialogData, locale, widgets) {
  const { titleIntlKey, messageIntlKey, buttons, analyticsEvent } = dialogData;
  return {
    title: path(titleIntlKey.split('.'), locale),
    content: path(messageIntlKey.split('.'), locale),
    analyticsEvent,
    buttons: sanitizeButtonsBeforeSendingToEvoWrapper(buttons, locale, widgets),
  };
}
